import { Clock, User } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import type { AppointmentStatus } from "@/lib/types";

interface AppointmentCardProps {
  client: string;
  service: string;
  staff: string;
  time: string;
  duration: number;
  status: AppointmentStatus;
  price: number;
  compact?: boolean;
}

export function AppointmentCard({ client, service, staff, time, duration, status, price, compact }: AppointmentCardProps) {
  if (compact) {
    return (
      <div className="flex items-center gap-4 rounded-lg border bg-card p-3 transition-colors hover:bg-secondary/50">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-sm font-semibold text-primary">
          {time.split(" ")[0]}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{client}</p>
          <p className="text-xs text-muted-foreground truncate">{service} · {staff}</p>
        </div>
        <StatusBadge status={status} />
      </div>
    );
  }

  return (
    <div className="rounded-xl border bg-card p-5 shadow-soft transition-shadow hover:shadow-card">
      <div className="flex items-start justify-between">
        <div>
          <h4 className="font-semibold text-card-foreground">{service}</h4>
          <div className="mt-1 flex items-center gap-2 text-sm text-muted-foreground">
            <User className="h-3.5 w-3.5" />
            <span>{client}</span>
          </div>
        </div>
        <StatusBadge status={status} />
      </div>
      <div className="mt-3 flex items-center gap-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-1">
          <Clock className="h-3.5 w-3.5" />
          <span>{time} · {duration}min</span>
        </div>
        <span>with {staff}</span>
      </div>
      {price > 0 && <p className="mt-2 text-sm font-semibold text-foreground">${price}</p>}
    </div>
  );
}
